// The tick that accepts SHUWA's Terms — required to create an account.
export default function TermsCheckbox({ checked, onChange, forBusiness = false }) {
  return (
    <label className="flex items-start gap-2 text-sm text-slate-700">
      <input
        type="checkbox"
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-input text-primary focus:ring-primary/20"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required
      />
      <span>
        I accept the SHUWA{" "}
        <a href="/legal/terms" target="_blank" rel="noreferrer" className="font-medium text-primary underline">Terms and Conditions</a>
        {forBusiness ? (
          <>
            ,{" "}
            <a href="/legal/business-guidelines" target="_blank" rel="noreferrer" className="font-medium text-primary underline">business guidelines</a>
          </>
        ) : null}{" "}
        and{" "}
        <a href="/legal/privacy" target="_blank" rel="noreferrer" className="font-medium text-primary underline">Privacy Policy</a>.
      </span>
    </label>
  );
}
